import { AdminTemplate,WorkplaceEntitlementManualEntryComponent } from "../../components";

export const WorkplaceEntitlementManualEntryPage = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "",
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true,
      }}
      showHeaderTitle={false}>
      <WorkplaceEntitlementManualEntryComponent />
    </AdminTemplate>
  );
};
